import React, { useRef } from 'react';

import {
  CatalogItemWrapper,
  CatalogTitleWrapper,
  ModuleName,
  Project,
  CatalogImageWrapper,
  PlusIconContainer,
  PlusIcon,
  CompareBtn,
} from './styles';

import { useUser} from "../../context/user";
import { user_roles} from "../../config/enums";
import { useEffect } from 'react';
import GridLoader from 'react-spinners/GridLoader';
import { primaryColor } from '../../config/colors';
import ImageViewer from '../ImageViewer';
import LazyLoadComponent from '../LazyLoadComponent';
import {useStandardization} from "../../screens/StandardizationScreen/context";

export default function CatalogListItem({
  catalog,
  isSelected,
  onClick,
  onCompare,
  showCompare,
  isDraggable = true,
  shouldRenderModuleItemAddIcon = false,
  onAddModuleButtonClick,
}) {
  const { imageId, name: moduleName, tsCode: moduleNumber, project, fpso } = catalog;
  const { user } = useUser();
  const {
    standardizationProject,
  } = useStandardization();
  const phase1EditRoles = [user_roles.stFraming, user_roles.stAdmin, user_roles.admin, user_roles.castAdmin];
  const phase2EditRoles = [user_roles.stProject, user_roles.stAdmin, user_roles.admin, user_roles.castAdmin];
  const canEditStandardizationProject = (standardizationProject?.phase === 1 && user?.roles.some(r => phase1EditRoles.includes(r))) ||
      (standardizationProject?.phase > 1 && user?.roles.some(r => phase2EditRoles.includes(r)));
  const isProject = fpso;

  const componentRef = useRef();

  useEffect(() => {
    if (isSelected) {
      componentRef.current.scrollIntoView();
    }
  }, [isSelected]);

  const onDragStart = (e) => {
    e.dataTransfer.setData('text/plain', JSON.stringify(catalog));
    // e.target.style.width = '60px';
    // e.target.style.padding = '5px';
  };

  const onDragEnd = (e) => {
    // e.target.style.width = '314px';
    // e.target.style.padding = '15px';
    // e.target.style.all = 'initial';
  };

  const handleOnAddModuleButtonClick = (event) => {
    event.stopPropagation();
    if (typeof onAddModuleButtonClick === 'function') {
      onAddModuleButtonClick();
    }
  };

  const handleOnCompareModuleButtonClick = (event) => {
    event.stopPropagation();
    if (typeof onCompare === 'function') {
      onCompare();
    }
  };

  return (
    <CatalogItemWrapper
      isSelected={isSelected}
      isProject={isProject}
      onClick={onClick}
      ref={componentRef}
      draggable={canEditStandardizationProject}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      unselectable={isDraggable ? 'on' : 'off'}>
      <CatalogImageWrapper>
        <LazyLoadComponent
          root={componentRef.current}
          rootMargin='300px'
          cmp={
            <ImageViewer
              fullscreen={false}
              imageId={imageId}
              containerStyle={{
                width: '50px',
                height: '50px',
              }}
              customLoader={
                <GridLoader
                  loading={true}
                  size={10}
                  color={primaryColor}
                  css='min-width: 55px'
                />
              }
            />
          }
        />
      </CatalogImageWrapper>
      <CatalogTitleWrapper>
        <ModuleName>
          {moduleNumber} - {moduleName}
        </ModuleName>
        <Project>{project}</Project>
        {showCompare && <CompareBtn onClick={handleOnCompareModuleButtonClick}>compare</CompareBtn>}
      </CatalogTitleWrapper>
      {shouldRenderModuleItemAddIcon && !isProject && (
        <PlusIconContainer>
          <PlusIcon
            title='Add module'
            onClick={handleOnAddModuleButtonClick}>
            +
          </PlusIcon>
        </PlusIconContainer>
      )}
    </CatalogItemWrapper>
  );
}
